import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AuthService } from "../../services/api/auth/auth.service";
import { TenantComponent } from "./variants/tenant/tenant.component";
import { AdminComponent } from "./variants/admin/admin.component";
import { CustomerComponent } from "./variants/customer/customer.component";
import { PermissionService } from "../../services/api/permission/permission.service";
import { HasPermissionDirective } from "../../shared/directives/has-permission/has-permission.directive";

@Component({
  standalone: true,
  selector: "app-home",
  imports: [TenantComponent, AdminComponent, CustomerComponent, HasPermissionDirective],
  templateUrl: "./home.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./home.component.scss",
})
export class HomeComponent implements OnInit {
  private auth = inject(AuthService);
  public permissions = inject(PermissionService);
  public role!: string;

  public ngOnInit() {
    const role = this.auth.getRole();
    if (role) {
      this.role = role;
    }
  }
}
